import { MALDIVES_CHARTER_BUNDLE_CAMPAIGN_TAG } from 'constants/charterFlight'
import { getIsCharterBundleOrder } from 'lib/order/orderUtils'

export function getIsMaldivesCharterBundleOrder(order: App.Order) {
  if (!getIsCharterBundleOrder(order)) return false
  const hasCampaignTags = order.items.some(item => {
    const campaignTags = item.offer.campaignTags
    return !!campaignTags?.length
  })
  if (!hasCampaignTags) return true
  return order.items.some(item =>
    item.offer.campaignTags?.includes(MALDIVES_CHARTER_BUNDLE_CAMPAIGN_TAG),
  )
}

export function isCharterUpgradeBlocked(order: App.Order) {
  return getIsCharterBundleOrder(order) && !getIsMaldivesCharterBundleOrder(order)
}
